import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";

import { AppClientComponent } from "../app.component";
import { AppClientRoutingModule } from "../app-routing.module";
import { CVV2Directive } from '../_directives/cvv2.directive';
import { IntegerOnlyDirective } from "../_directives/integer-only.directive";
import { OpenPayCardNumberDirective } from '../_directives/openpay-card-number.directive';
import { OpenPayExpirationYearDirective } from "../_directives/openpay-expiration-year.directive";
import { PhoneNumberDirective } from "../_directives/phone-number-validator.directive";
import { SafePipe } from "./pipes/safe.pipe ";
import { TranslatePipe } from "./pipes/translate.pipe";
import { MinMaxDirective } from "../_directives/min-max.directive";

@NgModule({
  declarations: [
    CVV2Directive,
    IntegerOnlyDirective,
    OpenPayCardNumberDirective,
    OpenPayExpirationYearDirective,
    PhoneNumberDirective,
    SafePipe,
    TranslatePipe,
    MinMaxDirective
  ],
  exports: [
    CVV2Directive,
    IntegerOnlyDirective,
    OpenPayCardNumberDirective,
    OpenPayExpirationYearDirective,
    PhoneNumberDirective,
    SafePipe,
    TranslatePipe,
    MinMaxDirective
  ],
  imports: [
    AppClientRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  bootstrap: [AppClientComponent],
  providers: []
})

export class ShareModule { }
